import { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import useSyncPushToken from 'screens/Auth/useSyncPushToken';
import AuthCheck from 'components/AuthCheck';
import useTraceReporting from 'hooks/useTraceReporting';
import SubRoutes from './SubRoutes';

const RouterContent = () => {
  return (
    <Routes>
      <Route path="*" element={<SubRoutes />} />
    </Routes>
  );
};

const Router = () => {
  useTraceReporting();
  useSyncPushToken();

  useEffect(() => {
    const event = new Event('app-loader-done');
    window.dispatchEvent(event);
  }, []);
  return (
    <AuthCheck>
      <BrowserRouter>
        <RouterContent />
      </BrowserRouter>
    </AuthCheck>
  );
};

export default Router;
